<template lang="pug">
  div
    .text-xs.neutral500--text.mt-3 {{ title }}
    search-patient-dropdown.mt-2.mb-3(v-model="selected" @change="handleChangePatient")
    .ml-2.my-2.text-xs.danger--text(v-if="!selected || errorMessage")
      div(v-if="!selected") Select a contact to
        span.lowercase &nbsp;{{ title }}
      div(v-if="errorMessage") {{ errorMessage }}
</template>

<script>
import SearchPatientDropdown from "@/components/clinic/registration/SearchPatientDropdown.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  components: {SearchPatientDropdown},
  props: {
    value: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    errorMessage: {
      type: String,
      default: null,
    },
    isFetching: {
      type: Boolean,
    },
  },
  data() {
    return {
      selected: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.isEmpty(this.value)) {
        this.selected = this.value
      }
    })
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
  },
  methods: {
    ...mapActions(['showMessage']),
    async handleChangePatient() {
      this.$emit('update:isFetching', true)
      await this.fetchPatient(this.selected.id)
      this.$emit('update:isFetching', false)
    },
    async fetchPatient(id) {
      if (!id) {
        return
      }
      try {
        const endpoint = `/clinics/${this.company.slug}/patients/${id}`
        const {data} = await this.axios.get(endpoint)
        this.$emit('input', data)
      } catch (e) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      }
    },
    isEmpty(obj) {
      if (obj === null || obj === undefined) {
        return true;
      }
      for (const prop in obj) {
        if (Object.hasOwn(obj, prop)) {
          return false
        }
      }
      return true
    },
  },
}
</script>

<style scoped>

</style>